import { render } from "./License.vue?vue&type=template&id=6949f629&scoped=true"
const script = {}

import "./License.vue?vue&type=style&index=0&id=6949f629&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6949f629"

export default script